export default __webpack_public_path__ + "static/media/Revertofficon.430517d8.svg";